<app-content>
  <app-breadcrumbs>
    <li>
      E-usługi
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      E-usługi
    </h2>
    <div class='row'>
      <div class='col-md-8'>
        <div class='form-group'>
          <label for='name'>Szukaj usługę</label>
          <input autocomplete='off' [(ngModel)]='filterValue' id='name' type='text'
                 placeholder='Szukaj po nazwię lub opisie' />
        </div>
      </div>
    </div>
    <div class='row'>
      <div class='col-md-8'>
        <ul class='item-list'>
          <li *ngFor='let item of (services() || []) | filterData: filterValue : false : "tag"'>
            <div>
              <a [routerLink]='"/e-uslugi" + item.url'>{{ item.name }}</a>
            </div>
            <div>
              <small>{{ item.description }}</small>
            </div>
          </li>
        </ul>
        <app-alert content='Brak wynników'
                   *ngIf='!((services() || []) | filterData: filterValue : false : "tag").length'
                   [closable]='false'>
        </app-alert>
      </div>
    </div>
  </section>
</app-content>
